import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Icon from '../Icon';
import HatchBuyButton from '../HatchBuyButton';
import tracking from '../../services/Tracking';
import MediaQuery from "react-responsive";
import { localeFormatted, configuratorType, version } from '../../i18n.js';

const hatchButtonAllowed =  (localeFormatted === 'nl_NL' || localeFormatted === 'da_DK') && configuratorType === 'shower' && version !== 'standalone';
const dealerButtonAllowed =  configuratorType === 'shower' && version !== 'standalone';


const Product = ({ data }) => (
  <div className="product-item">
    <h2 className="headline headline--h2" dangerouslySetInnerHTML={{ __html: data.headline }} />
    <MediaQuery maxWidth={767}>
      <div className="product-image-mobile">
        <img src={data.imageMedium} alt="" className="product-image-mobile__img" />
      </div>
    </MediaQuery>
    <h3 className="headline headline--h3"><span dangerouslySetInnerHTML={{ __html: data.subheadline }} /><br /><FormattedMessage id="results.product.number" values={{ number: data.id }} />
    </h3>
    {data.textblock_list && (
      <ul className="list list--mb">
        {data.textblock_list.map((item, j) => (
          <li key={j}>{item.item}</li>
        ))}
      </ul>
    )}
    <p dangerouslySetInnerHTML={{ __html: data.textblock_2nd_text }} className="text text--mbButtonsFollow" />
    {data.links
        .filter((link) => {
            console.log('link',link, localeFormatted , version, configuratorType, link.track_action);
            return (link.track_action === 'dealer-locator' && dealerButtonAllowed) || link.track_action !== 'dealer-locator';
        })
        .map((link, j) => (
      <span onClick={() => tracking.event(data.headline, link.track_action)} key={j}>
        <a target="_blank" className={'btn btn-block btn-primary button button--result ' + link.additionalClass} href={link.deeplink}>
          {link.icon &&
            <Icon name={link.icon} />}<FormattedMessage id={link.text} defaultMessage={link.text} />
        </a>
      </span>
    ))}
    {hatchButtonAllowed &&
    <HatchBuyButton data={data} additionalClass="" />
    }
  </div>
);

Product.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Product;



// WEBPACK FOOTER //
// ./src/components/product/Product.js